module.exports = __webpack_public_path__ + "img/nodeType4.67ec50ac.svg";